import React, { useState } from 'react';
import SearchInput from '../../../../../../../shared/design-system/components/atoms/search-input';
import { IconPlace } from '../../../../../../../shared/design-system/components/input/enums';
import { GetDoNotCallListDetailsPayload } from '../../../../../types/do-not-call-list';

type DetailsFilter = Pick<GetDoNotCallListDetailsPayload, 'page' | 'search'>;

type IProps = {
  filters: DetailsFilter;
  onFiltersChange: (
    payload: Partial<DetailsFilter>,
    resetSelection: boolean,
  ) => void;
};

const DoNotCallListDetailsSearch: React.FC<IProps> = ({
  filters,
  onFiltersChange,
}) => {
  const [search, setSearch] = useState(filters.search || '');

  const onSearch = () => {
    onFiltersChange({ search, page: 1 }, true);
  };

  const onClearSearch = () => {
    setSearch('');
    onFiltersChange({ search: '', page: 1 }, true);
  };

  return (
    <SearchInput
      searchValue={search}
      setSearchValue={setSearch}
      onSearch={onSearch}
      onClearSearch={onClearSearch}
      searchIconPlace={IconPlace.Left}
      searchIconFixed
      placeholder="Search by phone number"
      className="dnc-search-input lg"
    />
  );
};

export default DoNotCallListDetailsSearch;
